export default "__VITE_ASSET__BoFjD686__"